import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ChangePasswordDTO } from '../../model/ChangePasswordDTO';
import { CommonsUtils } from '../../../commons/CommonsUtils';
import { UserService } from '../../../services/user-service';
import { AuthService } from 'app/security/auth.service';
import { AuthenticationDTO } from 'app/side-by-side-template/model/AuthenticationDTO';
import { CommonsText } from '../../../commons/CommonsText';

@Component({
    selector: 'app-change-password-form',
    templateUrl: './change-password-form.component.html',
    styleUrls: ['./change-password-form.component.scss']
})

export class ChangePasswordFormComponent implements OnInit {

    @Output() onChangeSubmit = new EventEmitter();

    changePasswordForm: FormGroup;
    changePasswordDTO: ChangePasswordDTO;
    messages: String[] = null;
    recaptchaResolved: Boolean = false;
    running: Boolean;

    constructor(private formBuilder: FormBuilder, private route: ActivatedRoute,
        private userService: UserService, private router: Router,
        private authService: AuthService) { }

    ngOnInit() {
        this.changePasswordDTO = new ChangePasswordDTO();

        this.route.queryParams.subscribe(params => {
            this.changePasswordDTO.uuid = params['uuid'];
            this.changePasswordDTO.email = params['address'];
        });

        if ((this.changePasswordDTO.uuid === undefined) || (this.changePasswordDTO.email === undefined)) {
            this.router.navigate(['/authentication']);
        }

        this.changePasswordForm = this.formBuilder.group({

            email: [this.changePasswordDTO.email,
            [Validators.required,
            Validators.email, , Validators.pattern(CommonsUtils.EMAIL_REGEX)]],

            uuid: [this.changePasswordDTO.uuid,
            [Validators.required]],

            password: [this.changePasswordDTO.password,
            [Validators.required,
            Validators.pattern(CommonsUtils.PASSWORD_REGEX)]],

            password2: [this.changePasswordDTO.password2,
            [Validators.required,
            Validators.pattern(CommonsUtils.PASSWORD_REGEX),
            CommonsUtils.matchValues('password')]]

        })

        this.changePasswordForm.valueChanges.subscribe(data => { this.messages = null; });        

    }

    onChangePassword() {

        this.messages = [];
        if (this.submitEnabled()) {
            this.running = true;
            this.userService.onChangePassword(this.changePasswordForm.value)
                .then(success => {

                    if (success.response.value) {
                        const authentication = new AuthenticationDTO();
                        authentication.username = success.response.documentNumber;
                        authentication.password = this.changePasswordForm.value.password;
                        this.authService.onAuthenticate(authentication)
                            .then(success => {
                                this.authService.innovaLogin(authentication)
                                .then(success =>{
                                    this.router.navigate(['/entities']);
                                })
                                .catch(error =>{
                                    this.running = false;
                                    const error_description = error.error.error_description;
                
                                    switch (error_description) {
                                        case 'BLOCKED_BY_RGPD': {
                                            this.messages = [CommonsText.BLOCKED_BY_RGPD];
                                            break;
                                        }
                                        case 'WITHOUT_POLICIES': {
                                            this.messages = [CommonsText.WITHOUT_POLICIES];
                                            break;
                                        }
                                        default: {
                                            this.messages = [CommonsText.PARAMETROS_INCORRECTOS];
                                            break;
                                        }
                                    }
                                })
                                
                            }).catch(error => {

                                this.running = false;
                                const error_description = error.error.error_description;

                                switch (error_description) {
                                    case 'DISABLED': {
                                        this.messages = [CommonsText.DISABLED];
                                        break;
                                    }
                                    case 'BLOCKED': {
                                        this.messages = [CommonsText.BLOCKED];
                                        break;
                                    }
                                    case 'BLOCKED_BY_RENEWAL': {
                                        this.messages = [CommonsText.BLOCKED_BY_RENEWAL];
                                        break;
                                    }
                                    default: {
                                        this.messages = [CommonsText.PARAMETROS_INCORRECTOS];
                                        break;
                                    }
                                }

                            })
                    }


                }).catch(error => {
                    this.running = false;
                    const error_description = error.error.developerResponse;
                    switch (error_description) {
                        case 'BLOCKED_BY_RGPD': {
                            this.messages = [CommonsText.BLOCKED_BY_RGPD];
                            break;
                        }
                        case 'Invalid Parameter': {
                            this.messages = [CommonsText.CONTRASENIA_NO_COINCIDEN];
                            break;
                        }
                        default: {
                            this.messages = [CommonsText.ERROR_CAMBIO_PASS];
                            break;
                        }
                    }
                })
        }
    }

    onRecaptcha($event) {
        this.recaptchaResolved = true;
        if($event == null){
            this.recaptchaResolved = false;
        }
    }

    submitEnabled() {
        return this.changePasswordForm.valid && this.recaptchaResolved && (!this.running);
    }

    getButtonLabel() {
        return (this.running) ? CommonsText.CARGANDO : CommonsText.CONFIRMAR;
    }

}
